import React from "react";
import "./HypeScanner.css"; // make sure summary styles live here or adjust path

export default function CategoryRsiSummary({ items }) {
  if (!items || !items.length) return null;

  const accel = items.filter(i => i.trendLabel === "acceleration");
  const building = items.filter(i => i.trendLabel === "building");
  const cooling = items.filter(i => i.trendLabel === "cooling");
  const reversal = items.filter(i => i.trendLabel === "reversal");

  const highlightCat = (c, cls) => (
    <span key={c.slug || c.name} className={`summary-cat ${cls}`}>
      {c.name}
    </span>
  );

  return (
    <p className="category-summary">
      {accel.length > 0 && (
        <>
          <span className="summary-keyword accel">Acceleration:</span>{" "}
          {accel.slice(0, 3).map((c, i) => (
            <React.Fragment key={c.slug || c.name}>
              {highlightCat(c, "accel-cat")}
              {i < Math.min(accel.length, 3) - 1 ? ", " : " "}
            </React.Fragment>
          ))}
          are showing strong upside rotation. Look for fresh long setups and breakout entries in leading names, but keep stops tight.{" "}
        </>
      )}

      {building.length > 0 && (
        <>
          <span className="summary-keyword building">Building:</span>{" "}
          {building.slice(0, 3).map((c, i) => (
            <React.Fragment key={c.slug || c.name}>
              {highlightCat(c, "build-cat")}
              {i < Math.min(building.length, 3) - 1 ? ", " : " "}
            </React.Fragment>
          ))}
          are quietly gaining momentum – ideal for gradual scaling in and watchlist promotion.{" "}
        </>
      )}

      {cooling.length > 0 && (
        <>
          <span className="summary-keyword cooling">Cooling:</span>{" "}
          {cooling.slice(0, 2).map((c, i) => (
            <React.Fragment key={c.slug || c.name}>
              {highlightCat(c, "cool-cat")}
              {i < Math.min(cooling.length, 2) - 1 ? ", " : " "}
            </React.Fragment>
          ))}
          are losing steam; avoid new entries here and tighten risk on existing exposure.{" "}
        </>
      )}

      {reversal.length > 0 && (
        <>
          <span className="summary-keyword reversal">Reversal risk:</span>{" "}
          {reversal.slice(0, 2).map((c, i) => (
            <React.Fragment key={c.slug || c.name}>
              {highlightCat(c, "rev-cat")}
              {i < Math.min(reversal.length, 2) - 1 ? ", " : " "}
            </React.Fragment>
          ))}
          show clear downside rotation – these are candidates for de-risking or taking profits.{" "}
        </>
      )}
    </p>
  );
}
